<script>
import { mapState } from 'vuex';
import Length from '../../components/length.vue';
import Loading from '../../components/loading.vue';
import ShopDetailImages from '../../components/shopDetailImages.vue';

export default {
    name: "shopDetail",
    data() {
        return {
            length: 0,
            tabs: ['细节', '送货和退货'],
            tabActiveIndex: 0,
            detail: {
                banner: [],
                other_list: [],
            },
            isLoading: false,
            isLoadingAddCart: false,
        };
    },
    computed: {
        ...mapState(['isLogin'])
    },
    components: {
        ShopDetailImages,
        Length,
        Loading
    },
    mounted() {
        this.getDetail();
    },
    destroyed() {},
    watch: {
        '$route': {
            handler: 'getDetail'
        }
    },
    methods: {
        getDetail() { 
            this.isLoading = true;
            this.$store.dispatch('getShopDetail', {
                id: this.$route.query.id
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) {
                    this.detail = result.data;
                    if (result.data.qty > 0) { 
                        this.length = 1;
                    }
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        addCart() { 
            // 未登录，跳转登录
            if (!this.isLogin) { 
                this.toLogin();
                return;
            }
            // 
            if (this.isLoadingAddCart) { 
                return;
            }
            this.isLoadingAddCart = true;
            this.$store.dispatch('addCart', {
                id: this.detail.id,
                type: 1,
            }).then((result) => {
                this.isLoadingAddCart = false;
                if (result.code == 100) {
                    this.$showToast({ text: '添加成功' });
                } else if (result.code == 90) {
                    this.$showToast({ text: '登录凭证已失效' });
                    this.toLogin();
                } else if (result.code == 101) { 
                    this.$showToast({ text: '添加失败，库存不足' });
                } else if (result.code == 102) { 
                    this.$showToast({ text: '商品已经在购物车了' });
                }
            }).catch((err) => {
                this.isLoadingAddCart = false;
                this.$showToast({ text: '添加失败' });
            });
        },
        // 跳转登录
        toLogin() { 
            this.$router.push({
                path: '/login',
                query: {
                    redirect: this.$route.fullPath
                }
            })
        },
    },
};
</script>

<template>
    <div class="shop_detail layout_body">
        <div class="layout_main wrapper">
            <div class="layout_content" v-if="isLoading">
                <Loading/>
            </div>
            <template v-else>
                <div class="layout_content">
                    <p class="breadcrumb only_pc"><router-link to="/shop">A<sup>+</sup>Studio Shop</router-link> / {{ detail.name }}</p>
                    <div class="detail flex">
                        <ShopDetailImages :data="detail.banner"/>
                        <div class="info">
                            <p class="name">{{ detail.name }}</p>
                            <p class="price">RMB {{ detail.price }}</p>
                            <p class="inventory" v-if="detail.qty > 0">有存货</p>
                            <p class="inventory" v-else>无货</p>
                            <div class="length_group flex flex_column align_start">
                                <div class="title">数量</div>
                                <Length v-model="length" :min="detail.qty > 0 ? 1 : 0" :max="detail.qty"/>
                            </div>
                            <div class="btn_group flex">
                                <div class="btn layout_flex_center" v-if="isLoadingAddCart">
                                    <Loading type="smail"/>
                                </div>
                                <div class="btn layout_flex_center" v-else @click="addCart">添加到购物车</div>
                                <div class="btn layout_flex_center">立即购买</div>
                            </div>
                            <p class="vip"><a href="">A+Studio Shop 会员可享10%优惠 — 立即加入 &gt;</a></p>
                            <p class="logistics">订单超过300RMB在中国境内免费送货</p>
                        </div>
                    </div>
                    <div class="content">
                        <div class="tabs flex">
                            <div class="item" :class="{active: tabActiveIndex == index}" v-for="(item, index) in tabs" :key="index" @click="tabActiveIndex = index">{{ item }}</div>
                        </div>
                        <div class="details flex" v-if="tabActiveIndex == 0">
                            <div class="text" v-html="detail.content"></div>
                            <div class="info">
                                <p>{{ detail.tags }}</p>
                                <div class="list">
                                    <p class="name">{{ detail.name }}</p>
                                    <p class="value"></p>
                                    <template v-for="(item, index) in detail.attribute">
                                        <p class="name">{{ item.name }}</p>
                                        <p class="value">{{ item.value }}</p>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="details" v-if="tabActiveIndex == 1">

                        </div>
                    </div>
                </div>
                <div class="layout_content" v-if="detail.other_list.length > 0">
                    <div class="top center">
                        <p class="title">你可能会喜欢</p>
                    </div>
                    <div class="category_list type2 flex">
                        <div class="item" v-for="(item, index) in detail.other_list" :key="index">
                            <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                            <p class="name">{{ item.name }}</p>
                            <p class="price" v-if="item.price == '0.00'">免费</p>
                            <p class="price" v-else>RMB {{ item.price }}</p>
                            <router-link class="link" :to="`/shop/detail?id=${item.id}`">了解更多</router-link>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<style scoped lang="scss">
.shop_detail{
    position: relative;
    z-index: 1;
}
.wrapper{
    padding-top: 1.28rem;
    @media only screen and (max-width: 750px) {
        width: 100%;
        padding: 0;
    }
}
.content{
    padding: 0 .5rem;
    @media only screen and (max-width: 750px) {
        padding: 0;
    }
    .tabs{
        border-bottom: 1px solid #999;
        font-size: .18rem;
        line-height: 2;
        color: #666;
        gap: .3rem;
        margin-bottom: .5rem;
        .item{
            position: relative;
            cursor: pointer;
            &::after{
                content: "";
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                border-bottom: 1px solid #000;
                display: none;
            }
            &.active{
                &::after{
                    display: block;
                }
            }
        }
        @media only screen and (max-width: 750px) {
            font-size: .28rem;
        }
    }
    .details{
        font-size: .18rem;
        color: #666;
        gap: .8rem;
        .text{
            flex: 1;
        }
        .info{
            width: 4rem;
            .list{
                padding-top: .3rem;
            }
            .name{
                color: var(--font_color);
                font-weight: bold;
            }
            .value{
                margin-bottom: .1rem;
            }
        }
        @media only screen and (max-width: 750px) {
            font-size: .28rem;
            flex-direction: column;
            gap: .5rem;
            margin-bottom: .5rem;
            .info{
                width: 100%;
                .list{
                    padding-top: 0;
                }
                .value{
                    margin-bottom: .2rem;
                }
            }
        }
    }
}
.detail{
    margin-bottom: .7rem;
    @media only screen and (max-width: 750px) {
        flex-direction: column;
    }
    .info{
        flex: 1;
        margin-left: .4rem;
        padding-top: .4rem;
        @media only screen and (max-width: 750px) {
            margin-left: 0;
        }
        .name{
            font-size: .5rem;
            margin-bottom: .2rem;
        }
        .price{
            font-size: .26rem;
            margin-bottom: .2rem;
            @media only screen and (max-width: 750px) {
                font-size: .28rem;
            }
        }
        .inventory{
            font-size: .18rem;
            margin-bottom: .2rem;
            color: #666;
            @media only screen and (max-width: 750px) {
                font-size: .28rem;
                margin-bottom: .3rem;
            }
        }
        .length_group{
            margin-bottom: .3rem;
            .title{
                font-size: .18rem;
                margin-bottom: .1rem;
            }
            @media only screen and (max-width: 750px) {
                margin-bottom: .4rem;
                .title{
                    font-size: .26rem;
                    margin-bottom: .2rem;
                }
            }
        }
        .btn_group{
            gap: .3rem;
            margin-bottom: .3rem;
            .btn{
                border: 1px solid #000;
                padding: 0 .3rem;
                height: .45rem;
                font-size: .18rem;
                cursor: pointer;
            }
            @media only screen and (max-width: 750px) {
                margin-bottom: .4rem;
                .btn{
                    flex: 1;
                    height: .6rem;
                    font-size: .28rem;
                }
            }
        }
        .vip,
        .logistics{
            font-size: .18rem;
            color: #666;
            @media only screen and (max-width: 750px) {
                text-align: center;
                font-size: .28rem;
            }
        }
        .vip{
            a{
                border-bottom: 1px solid #666;
            }
        }
    }
}
.layout_content{
    &:first-child{
        margin-top: 0;
    }
    .top{
        margin-bottom: .4rem;
        &.center{
            text-align: center;
        }
        .title{
            font-size: .25rem;
            margin-bottom: .1rem;
            font-weight: bold;
            @media only screen and (max-width: 750px) {
                font-size: .36rem;
            }
        }
        .desc{
            font-size: .2rem;
        }
    }
    .breadcrumb{
        font-size: .2rem;
        color: #666;
        margin-bottom: .3rem;
    }
    
    .category_list{
        gap: .5rem;
        &.type2{
            .item{
                flex: none;
                width: 3.4rem;
            }
            @media only screen and (max-width: 750px) {
                gap: .3rem;
                font-size: .26rem;
                .item{
                    width: 3.3rem;
                }
            }
        }
        .item{
            flex: 1;
            font-size: .18rem;
            text-align: center;
            line-height: 2;
            .cover{
                height: 0;
                padding-bottom: 100%;
                // border: 1px solid #999;
                margin-bottom: .3rem;
            }
            .link{
                color: #999;
            }
        }
    }
}
</style>